import React from 'react'
import styled from 'styled-components'

const NewLabelContainer = styled.div`
  flex-grow: 1;
  position: relative;
`

const NewLabelText = styled.div`
  background: ${props => props.theme.regional.newLabelBackground};
  border: 1px solid ${props => props.theme.regional.newLabelBorder};
  border-radius: 4px;
  bottom: 3.5px;
  color: ${props => props.theme.regional.color};
  font-size: 12px;
  font-weight: bold;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  font-family: Arial,lucida,helvetica,sans-serif;
  position: absolute;
  top: -5px;
  left: -15px;
  z-index: 20;
`

export const NewLabelDesktop = () => (
  <NewLabelContainer>
    <NewLabelText>nové</NewLabelText>
  </NewLabelContainer>
)
